/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flow_0_0_2, getFullItemOne, MakeServerCall, getCurrentUser } from '@flexus/core';
import { map, filter, take } from 'rxjs';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';


export const PGG_CONTEXT_MENU_NOTES: Flow_0_0_2 = {
	id: 'Notes',
	itemType: 'flow',
	name: 'Notes',
	excludeForOnlyStates: [169],
	excludeForOnlyRoles: [18],
	header: {
		title: (_store: Store) => {
			return _store.select(getFullItemOne).pipe(
				map((itemOne: any) => {
					if (itemOne) {
						const uniqueClaimRef =
							itemOne?.loan_information?.voucher_key ?? itemOne?.mid;
						return `View notes  :   ${uniqueClaimRef}  -  ${itemOne?.applicant?.first_name}`;
					} else {
						return 'View notes';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	startNode: 'Notes',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	actionPanel: () => {
		return () => {
			return [{}];
		};
	},
	nodes: {
		Notes: {
			component: 'NotesComponent',
			hasLoader: false,
			inputs: {
				title: 'Add Claim Note',
				location: 'context-menu',
				formInputs: {
					0: {
						formControlName: 'message',
						inputType: 'textarea',
						label: 'Add Note',
						placeholder: 'Type a note'
					}
				},
				submitFunction: instance => {
					instance._store.dispatch(
						new MakeServerCall({
							dataKey: 'notes',
							serviceVariable: 'silService',
							functionName: 'addClaimNote',
							errorMessage: 'Could not add note'
						})
					);
					instance?.bf?.bigForm?.patchValue({ message: '' });
					instance?.bf?.bigForm?.markAsPristine();
				}
			},
			initFormFields: (bf) => {
				bf.bigForm.addControl('message', new UntypedFormControl('', Validators.required));
			}
		}
	},
	serverCalls: {
		username: {
			errorMessage: 'No user found.',
			directCall: (http, store) =>
				store.select(getCurrentUser).pipe(
					filter(Boolean),
					take(1),
					map((user: any) => {
						return user?.user?.full_name ?? '';
					})
				)
		},
		notes: {
			serviceVariable: 'silService',
			functionName: 'getClaimNotes',
			errorMessage: 'No claim notes could be found!'
		}
	}
};
